import { Empty } from 'antd';
import type { RankingRow } from '../contract';
import { KIND_LABEL, creatorName, fmtHours, fmtKc, trendTag } from '../format';
import styles from '../style.module.scss';

interface Props {
  rows: RankingRow[];
  onSelect: (uid: string) => void;
}

/** Top 10 KC của phạm vi (overview.ranking). Bấm một dòng → Drawer chi tiết; danh sách đủ ở bảng dưới. */
const RankingList = ({ rows, onSelect }: Props) => (
  <section className={styles.card} aria-label="Top 10 Kim cương">
    <h2 className={styles.cardTitle}>Top 10 Kim cương</h2>
    {rows.length === 0 ? (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có Creator nào." />
    ) : (
      <ol className={styles.ranking}>
        {rows.map((r, i) => {
          const t = trendTag(r.trend, r.delta7Pct);
          return (
            <li key={r.uid}>
              <button type="button" className={styles.rankingRow} onClick={() => onSelect(r.uid)}>
                <span className={styles.rankingNo}>{i + 1}</span>
                <span className={styles.rankingWho}>
                  <span className={styles.cellName}>{creatorName(r)}</span>
                  <span className={styles.cellGroup}>
                    {KIND_LABEL[r.kind] || r.kind}
                    {r.groupName ? ` · ${r.groupName}` : ''} · {fmtHours(r.liveHours)}
                  </span>
                </span>
                <span className={styles.rankingKc}>
                  <strong>{fmtKc(r.diamonds)}</strong>
                  <span className={styles.trend} style={{ color: t.color }}>
                    {t.text}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    )}
  </section>
);

export default RankingList;
